import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'

export default function NormalInput({boxClassName, label, value, onChange, labelClass, icon, name, type, placeholder, disabled}) {

  return (
    <div className={`my-3 ${boxClassName}`}>
        <label className={`block text-gray-700 text-sm mb-2 capitalize`} for={name}>
            {label||name}
        </label>
        <div className='flex w-full items-center shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
                leading-tight '>
          <FontAwesomeIcon className='mr-2 text-theme/80' size='lg' icon={icon} />
          <input 
          name={name} 
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="w-full focus:outline-none focus:shadow-outline" id={name}/>
        </div>
    </div>
  )
}
